// SIGN IN
export const GOOGLE_SIGN_IN_ERROR = 'Google sign in failed. Try again.';

export const SUBMIT_ERROR = 'Error encountered while trying to submit';
export const SOMETHING_WENT_WRONG = 'Something went wrong';

// Business Onboarding
export const ONBOARDING_START_ERROR = `There was a problem starting 'Business Onboarding' process.`;
export const ONBOARDING_UPDATE_ERROR = `There was a problem updating 'Business Onboarding' process.`;
export const ONBOARDING_DETAILS_ERROR = `There was a problem fetching 'Business Onboarding' details.`;
export const CLAIM_BUSINESS_ERROR = 'Failed to claim the business.';
export const CLAIM_BUSINESS_ERROR_CLAIMED =
  'This business is already claimed. Please contact the business owner to get invited.';
export const BUSINESSE_CREATE_ERROR = 'There was a problem creating a new business.';
export const JOINING_COMMUNITY_ERROR = `There was a problem while 'Joining Community'.`;
export const ADDING_WAITLIST_ERROR = `There was a problem while 'Joining Waitlist'.`;

// POS
export const POS_SUCCESS = 'Added POS information successfully.';
export const POS_ERROR = `There was a problem adding 'POS information'.`;
export const POS_VERIFY_ERROR_TITLE = `Unable to fetch 'POS Information'`;
export const POS_VERIFY_ERROR = `We are unable to fetch your POS Information. Please try again.`;

// SUPPORT
export const SUPPORT_SUCCESS = 'We have sent your details to our support. They will contact you soon.';
export const SUPPORT_ERROR = `There was a problem in 'Contacting Support'.`;

// BANK DETAILS
export const ADD_ACCOUNT_SUCCESS = 'Bank account added successfully.';
export const DELETE_ACCOUNT_ERROR = 'Delete account failed. Please try again.';
export const CARD_SUCCESS = 'Card added successfully.';
export const CARD_ERROR = `There was a problem 'Adding Card'.`;

// FETCHING BUSINESSES/COMMUNITIES
export const fetchingError = (data: string) => `There was a problem fetching '${data}'.`;

// EMAIL VERIFICATION
export const RESEND_ERROR = 'Resend OTP failed. Please try again.';
export const sentCodeSuccess = (email: string, resent: boolean = false) =>
  `The verification code is ${resent ? 'resent' : 'sent'} to ${email}. Please verify using that code.`;

// USER MANAGEMENT
export const addUserToBusinessSuccess = (business: string) => `You were added in ${business}`;
